import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";

function useUserMe() {
  const token = localStorage.getItem("token"); // Get token from cookie

  return useSWR(
    token
      ? {
          path: `/api/v1/auth/me`,
          method: "GET",
          token,
        }
      : null, // Use `null` to disable fetch when token is not present
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useUserMe;
